import React from 'react';
import { usePlotArea, useYAxisScale } from 'recharts';

export interface FmRowLabelText {
  id: string;
  /** The row's value on the category axis. */
  category: string;
  left: string;
  right: string;
  /** Accessible words for a glyph-only `right`. */
  rightLabel?: string;
}

/** Gap between a row's text baseline and the top of its band. */
const TEXT_BASELINE = 16;

/**
 * Row text above each horizontal bar row — label left, value or verdict right
 * — placed with the chart's own category scale, so the plot keeps the full
 * width at a phone viewport and text never drifts from its row.
 */
export const FmRowLabels: React.FC<{
  rows: readonly FmRowLabelText[];
  fontSize: number;
}> = ({ rows, fontSize }) => {
  const plot = usePlotArea();
  const yScale = useYAxisScale();
  if (!plot || !yScale) return null;
  return (
    <g className="fm-chart-row-labels">
      {rows.map((row) => {
        const bandTop = yScale(row.category);
        if (bandTop === undefined) return null;
        const y = bandTop + TEXT_BASELINE;
        return (
          <g key={row.id}>
            <text x={plot.x} y={y} fontSize={fontSize} fill="var(--fm-chart-label)">
              {row.left}
            </text>
            <text
              x={plot.x + plot.width}
              y={y}
              fontSize={fontSize}
              fill="var(--fm-d-fg)"
              textAnchor="end"
              aria-label={row.rightLabel}
              data-testid="chart-row-value"
            >
              {row.right}
            </text>
          </g>
        );
      })}
    </g>
  );
};
